import React from "react";

const partnerLogos = [
  {
    src: "/img/partner-logos/calseed.png",
    alt: "CalSEED",
    href: "https://calseed.fund/",
    wrapperClassName: "w-[120px] md:w-[130px] lg:w-[140px]",
  },
  {
    src: "/img/partner-logos/scaqmd.png",
    alt: "SCAQMD",
    href: "https://www.scaqmd.gov/",
    wrapperClassName: "w-[120px] md:w-[140px] lg:w-[144px]",
  },
  {
    src: "/img/partner-logos/nyserda.png",
    alt: "NYSERDA",
    href: "https://www.nyserda.ny.gov/",
    wrapperClassName: "w-[120px] md:w-[140px] lg:w-[140px]",
  },
  {
    src: "/img/partner-logos/calstart.png",
    alt: "Calstart",
    href: "https://calstart.org/",
    wrapperClassName: "w-[72px] md:w-[88px] lg:w-[88px]",
  },
  {
    src: "/img/partner-logos/cleantechopen.png",
    alt: "Cleantech Open",
    href: "https://www.cleantechopen.org/",
    wrapperClassName: "w-[104px] md:w-[120px] lg:w-[124px]",
  },
];

export const LandingTrustedBy = () => (
  <section id="trusted-by" className="scroll-mt-24 bg-white py-8 md:py-12">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 className="mb-6 text-lg font-semibold uppercase tracking-wider text-blue-700 md:text-xl">
        Partners
      </h2>

      <div className="mx-auto max-w-4xl">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-6 px-2 md:gap-x-8 lg:flex-nowrap lg:justify-between lg:gap-x-4 lg:px-6">
          {partnerLogos.map(({ src, alt, href, wrapperClassName }) => (
            <a
              key={alt}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={`Visit ${alt}`}
              className={`flex h-12 shrink-0 items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-2 md:h-16 ${wrapperClassName}`}
            >
              <img
                src={src}
                alt={alt}
                className="h-auto max-h-full w-full object-contain opacity-80 transition-opacity duration-300 hover:opacity-100"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);
